<template>

    <v-container v-if="evento_id"  >
        <v-flex xs12 sm6 class="py-2">
          
            <v-btn-toggle v-model="verAptosMedicos">
              <v-btn flat value="sent" >
                Aptos Recibidos
              </v-btn>
              <v-btn flat value="pending_send">
                Personas que no enviaron
              </v-btn>
            
            </v-btn-toggle>
          </v-flex>

        <v-container>

        <div v-if="verAptosMedicos === 'sent'">
            <AptosFiltros @updateFilter="updateFilters" />
            <AptosTabla :evento_id="evento_id" :filters="filters" ref="aptosMedicosTabla" @validarApto="openValidarAptoMedico" />
            <AptoDialog :evento_id="evento_id" ref="validationDialog" @reload="reload" @close="closeDialog"/>
        </div>
        <div v-if="verAptosMedicos == 'pending_send'">
            <TokenAptosFiltros @updateFilter="updateFiltersNoEnviaron"  /> 
            <v-layout justify-end>
                <v-btn @click="confirmSendMassiveRemider" color="primary" small>Enviar Recordatorio a todos</v-btn>
            </v-layout>
            <NoEnviaronTabla :evento_id="evento_id" ref="noEnviaronTabla" />
        </div>

        </v-container>


    </v-container>
</template>
<script>
import AptoDialog from './components/AptoDialog.vue';
import AptosTabla from './components/AptosTabla.vue'; 
import AptosFiltros from './components/AptosFiltros.vue';
import TokenAptosFiltros from './components/TokenAptosFiltros.vue';
import NoEnviaronTabla from './components/NoEnviaronTabla.vue';
import aptosMedicosApi from '../../../../api/aptos';

export default {
    data() {
        return { 
            evento_id: null, 
            aptoToValidate: null,
            verAptosMedicos: "sent",
        }   
    },
    mounted() {
        this.evento_id = this.$route.params.id;
    },
    methods: {
        closeDialog() {
            this.aptoToValidate = null;
        },
        openValidarAptoMedico(apto) {
            this.aptoToValidate = apto; 
            this.$refs.validationDialog.openValidarAptoMedico(apto);
           
        },
        reload() {
            this.$refs.aptosMedicosTabla.loadData();
        },
        updateFilters(filters) {
            console.log('updateFilters', filters);
            this.$refs.aptosMedicosTabla.applyFilters(filters);
        },
        updateFiltersNoEnviaron(filters) {
            console.log('updateFiltersNoEnviaron', filters);
            this.$refs.noEnviaronTabla.applyFilters(filters);
        },
        confirmSendMassiveRemider() {
            const confirm = window.confirm("¿Está seguro que desea enviar el recordatorio a todos los que no enviaron el apto médico?");
            if (confirm) {
                this.queueSendEmailsJob();
            }
        },
        queueSendEmailsJob() {
            aptosMedicosApi.queueSendEmailsJob(this.evento_id)
                .then(response => {
                    this.$store.commit('app/SET_MESSAGE', 'Recordatorio enviado a todos los que no enviaron el apto médico');
                    this.$store.commit('app/SET_TYPE', 'success');
                    this.$store.commit('app/SET_SHOW', true);
                    
                })
                .catch(error => {
                    console.error(error);
                    this.$store.commit('app/SET_MESSAGE', 'Error al enviar el recordatorio a todos los que no enviaron el apto médico');
                    this.$store.commit('app/SET_TYPE', 'error');
                    this.$store.commit('app/SET_SHOW', true);
                });
        }
    },
    components: {
        AptosTabla, AptoDialog, AptosFiltros,NoEnviaronTabla, TokenAptosFiltros
    }
}
</script>